export const AUTH_COPY = {
  FORGOT: {
    /** Se MUEVE aquí, idéntico, desde forgot-password-form.component.ts:19. */
    GENERIC_ERROR: 'Ha ocurrido un error. Por favor, inténtalo de nuevo.',
    /** Botón en espera tras un 429. `{s}` = segundos que quedan. Mismo texto que el de ajustes del perfil. */
    LINK_WAIT: 'Enviar enlace en {s} s',
    /** Ayuda bajo el «no hay cuenta» del 422: las tres partes forman UNA frase, con el enlace en la del medio. */
    NO_ACCOUNT_HINT: '¿Compraste en la tienda sin registrarte?',
    NO_ACCOUNT_LINK: 'Crea tu cuenta web',
    NO_ACCOUNT_SUFFIX: 'con este mismo correo.',
  },
  REGISTER: {
    /** 422 del campo `email` que NO es «ya registrado» (`validation.email`, `validation.required`…). */
    EMAIL_INVALID: 'Revisa el correo: no parece una dirección válida.',
  },
} as const;
